import {
  List,
  Datagrid,
  TextField,
  TextInput,
  DateField,
  useListContext,
} from "react-admin";

const personFilters = [
  <TextInput source="fullName" label="Full Name" alwaysOn />,
];

const PersonListContent = () => {
  const { data, isLoading } = useListContext();
  console.log("PersonList data:", data);
  console.log("PersonList isLoading:", isLoading);

  return (
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="type" />
      <TextField source="lastName" />
      <TextField source="firstName" />
      <TextField source="middleName" />
      <TextField source="fullName" />
      <DateField source="createdAt" />
      <TextField source="createdBy" />
      <DateField source="modifiedAt" />
      <TextField source="modifiedBy" />
    </Datagrid>
  );
};

export const PersonList = () => (
  <List filters={personFilters}>
    <PersonListContent />
  </List>
);
